import React from 'react';

interface SectionDividerProps {
  label?: string;
  className?: string;
  id?: string;
}

export function SectionDivider({ label, className = '', id }: SectionDividerProps) {
  return (
    <div id={id} className={`border-t border-gray-200 dark:border-gray-700 my-20 ${className}`} style={{ scrollMarginTop: '6rem' }}>
      {label && (
        <div className="max-w-4xl mx-auto text-center -mt-4">
          <span className="bg-white dark:bg-gray-900 px-6 py-2 text-sm font-medium text-gray-500 dark:text-gray-400 uppercase tracking-wide">
            {label}
          </span>
        </div>
      )}
    </div>
  );
} 